import { useEffect, useState } from "react";
import DataTableBase from "../../common/Datatable";
import { Link } from "react-router-dom";
import moment from "moment";
import { trainerService } from "../../../../api/services";
import makeRequest from "../../../../api";
import { toast } from "react-toastify";

const PermissionsListing = () => {
  const [permissionsList, setPermissionList] = useState<any>([]);

  const fetchPermissions = async () => {
    try {
      const res = await makeRequest(trainerService.getTrainerPermissionList());
      setPermissionList([...res?.data?.body?.permissions]);
    } catch (error: any) {
      toast.error("Error fetching permissions list!");
    }
  };

  useEffect(() => {
    fetchPermissions();
  }, []);

  const columns = [
    {
      name: "Permission name",
      selector: (row: any) => row.permissionDisplayName,
      cell: (row: any) => {
        return (
          <Link to={`${row.permissionId}`}>{row.permissionDisplayName}</Link>
        );
      },
      sortable: true,
    },
    {
      name: "Permission value",
      selector: (row: any) => row.permissionValue,
    },
    {
      name: "Created at",
      selector: (row: any) => row.createdAtEpoch,
      cell: (row: any) =>
        moment(row.createdAtEpoch).format("DD MMM YYYY, hh:mm A"),
      sortable: true,
    },
  ];

  return (
    <div className="container-lg">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Permissions
            </li>
          </ol>
        </nav>
        <Link to="add" className="btn btn-sm btn-outline-secondary">
          Add permission
        </Link>
      </div>
      <DataTableBase columns={columns} data={permissionsList} />
    </div>
  );
};

export default PermissionsListing;
